import {useQuery} from 'react-query';
import {getSubBrandDetailById} from './getSubBrandDetailById';

const useGetSubBrandDetailById = (subBrandId?: string) => {
  const {data, isLoading} = useQuery(
    ['get-sub-brand-detail-by-id', subBrandId],
    () => getSubBrandDetailById(subBrandId),
    {enabled: Boolean(subBrandId)},
  );

  return {data, isLoading};
};

export default useGetSubBrandDetailById;
